import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { bool, oneOf } from "prop-types";
import gButtonColors, { colors } from "glesys-controlpanel/helpers/g-button-color";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import Content from "./content";

@forbidExtraArgs
export default class extends Component {
  @arg(oneOf(["button", "submit"])) type = "button";

  @arg(bool) disabled = false;

  @arg(bool) loading = false;

  @arg(oneOf(colors)) color;

  @arg(oneOf([null, "default", "compact"])) display;

  get stateClasses() {
    return this.isDisabled ? "cursor-not-allowed" : "cursor-pointer";
  }

  get isDisabled() {
    return this.disabled || this.loading;
  }

  get isCompact() {
    return this.display === "compact";
  }

  <template>
    <button
      class="flex items-center relative rounded text-sm
        {{if this.isCompact 'px-2 py-1' 'px-4 py-2'}}
        {{this.stateClasses}}
        {{gButtonColors this.color}}
        disabled:opacity-60 transition-all duration-200"
      type={{this.type}}
      disabled={{this.isDisabled}}
      {{mergeClasses}}
      ...attributes
    >
      <Content @loading={{this.loading}} @color={{this.color}}>
        {{yield}}
      </Content>
    </button>
  </template>
}
